import { render, staticRenderFns } from "./AudioTrack.vue?vue&type=template&id=3754045a&"
import script from "./AudioTrack.vue?vue&type=script&lang=js&"
export * from "./AudioTrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports